<template>
<div class="player">
  <div class="player_name">{{video.name}}</div>
  <video :id='"A"+video.index'
         style="width: 100%;"
         class="video-js vjs-default-skin vjs-big-play-centered  "> </video>
</div>
</template>

<script>
  export default {
    name: "playVideo",
    props: {
      video: {
        url: "",
        index:0,
      }
    },
    data() {return {}},
    mounted() {
      this.initVideoPlayer();
    },
    methods: {
      initVideoPlayer() {
        var that=this;
        var id="#A"+this.video.index;
          const currentInstance = that.$video(document.querySelector(id),{
            autoplay:true,
            controls:true
          }).src({
            src: that.video.url,
            type: 'application/x-mpegURL',
          })
          console.log('that.video.url',that.video.url)
      },
    }
  }
</script>
<style scoped>
  .player  {
    background-color: black;
    width: 100%;
    height: 100%;
    border: 1px solid white;
    color: white;
    text-align: center;
    box-sizing: border-box;
  }
  .player_name{
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/nursingRoom/playVideo.vue